import React, { createContext, useReducer, useContext } from 'react';

import { initialState, PaymentState, reducer } from './paymentsReducer';

interface PaymentsContextInterface {
  state: PaymentState;
  dispatch: React.Dispatch<any>;
}

export const PaymentsContext = createContext<PaymentsContextInterface>({
  state: initialState,
  dispatch: () => {},
});

const PaymentStoreProvider = ({
  children,
}: React.PropsWithChildren<any>): React.ReactElement => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <PaymentsContext.Provider value={{ state, dispatch }}>
      {children}
    </PaymentsContext.Provider>
  );
};

const usePaymentsContext = () => useContext(PaymentsContext);

export { PaymentStoreProvider, usePaymentsContext };
